import i18n from 'i18next';
import resourcesToBackend from 'i18next-resources-to-backend';
import { initReactI18next } from 'react-i18next';

export const LOCALES = [
  'en',
  'de',
  'pt',
  'ru',
  'uk',
  'vi',
  'ro',
  'pl',
  'nl',
] as const;
export type Locale = (typeof LOCALES)[number];

export const LOCALE_LABELS: Record<Locale, string> = {
  en: 'English',
  de: 'Deutsch',
  pt: 'Português',
  ru: 'Русский',
  uk: 'Українська',
  vi: 'Tiếng Việt',
  ro: 'Română',
  pl: 'Polski',
  nl: 'Nederlands',
};

i18n
  .use(
    resourcesToBackend(
      (language: string, namespace: string) =>
        import(`../locales/${language}/${namespace}.json`),
    ),
  )
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    supportedLngs: LOCALES,
    defaultNS: 'common',
    interpolation: { escapeValue: false },
    // Fall back to English for any missing key so new locales never break the UI
    ns: ['common', 'services'],
  });

export default i18n;
